import React from 'react';

import { triggerGoogleAnalyticsEvent } from './trigger-google-analytics-event';

export const UPGRADE_EXPERIMENT_MISS_GTM_EVENT =
  'upgrade_experiment_redirect_to_checkout';

export const UPGRADE_EXPERIMENT_HIT_GTM_EVENT =
  'upgrade_experiment_show_plan_picker_modal';

export const createUpgradeClickHandler =
  (
    experimentEnabled: boolean,
    onTriggerExperiment: () => void,
    fallback?: () => void
  ) =>
  (e: React.MouseEvent) => {
    if (!experimentEnabled) {
      triggerGoogleAnalyticsEvent(UPGRADE_EXPERIMENT_MISS_GTM_EVENT);
      fallback?.();
      return;
    }

    e.preventDefault();
    triggerGoogleAnalyticsEvent(UPGRADE_EXPERIMENT_HIT_GTM_EVENT);
    onTriggerExperiment();
  };
